import AddProductComment from '../add-shared/AddProductComment';
import AddProductForm from '../add-shared/AddProductForm';
import patch from '../add-shared/patch';

export default {
  label: 'Add Product',
  value: 'Add Product',
  Comment: AddProductComment,
  Form: AddProductForm,
  patch,
  initialState() {
    return { campaignLines: [] }; // This initializes the change object. It is provided as `value` to the form component
  },
};
